(function () {
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.hover-quick-add__size');
    if (!btn || btn.disabled) return;

    e.preventDefault();
    e.stopPropagation();

    const variantId = btn.dataset.variantId;
    const container = btn.closest('.hover-quick-add');
    const feedback = container?.querySelector('.hover-quick-add__feedback');

    if (!variantId || !container) return;

    btn.style.opacity = '0.5';
    btn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      if (!res.ok) throw new Error('Error al añadir');

      // Obtener el carrito actualizado
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();

      // ✅ Disparar el evento exacto que escucha el tema
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          data: {
            itemCount: 1,           // unidades añadidas en esta acción
            source: 'product-form-component', // hace que el cart drawer se abra
            variantId: variantId,
          }
        }
      }));

      // Feedback visual
      if (feedback) {
        feedback.textContent = '✓ Añadido al carrito';
        feedback.classList.remove('hover-quick-add__feedback--error');
        setTimeout(() => { feedback.textContent = ''; }, 2500);
      }

    } catch {
      if (feedback) {
        feedback.textContent = 'Error. Inténtalo de nuevo.';
        feedback.classList.add('hover-quick-add__feedback--error');
        setTimeout(() => {
          feedback.textContent = '';
          feedback.classList.remove('hover-quick-add__feedback--error');
        }, 3000);
      }
    } finally {
      btn.style.opacity = '';
      btn.disabled = false;
    }
  });
})();
